const Happy2 = [
    {id: "0", value: "極度悲觀價"},    
    {id: "1", value: "過度悲觀價"},
    {id: "2", value: "合理價"}, 
    {id: "3", value: "過度樂觀價"}, 
    {id: "4", value: "極度樂觀價"},       
  ];  
  
  export default Happy2